import React, { useMemo } from "react"
import { ApexOptions } from "apexcharts"
import { getChartColorsArray } from "utils/chartColors"
import ReactApexChart from "react-apexcharts"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import { useTranslation } from "react-i18next"

const Disputes = () => {
  const { t } = useTranslation()

  const spineareaChartColors = getChartColorsArray([
    "--bs-primary",
    "--bs-cyan",
    "--bs-secondary",
  ])
  const basicColor = ["success", "cyan", "secondary"]
  const series = [
    {
      name: "Inflation",
      data: [50, 30, 20],
    },
  ]

  const labels = useMemo(() => {
    return [
      t("common_resolved"),
      t("customers_pending"),
      t("customers_escalated"),
    ]
  }, [t])

  const options: ApexOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: false, // ✅ hide built-in legend
    },
    plotOptions: {
      bar: {
        distributed: true,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return val + "%"
      },
      offsetY: -30,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },

    colors: spineareaChartColors,
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: labels,
      position: "top",
      labels: {
        offsetY: -18,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
        offsetY: -35,
      },
    },
    fill: {
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.25,
        gradientToColors: undefined,
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [50, 0, 100, 100],
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return val + "%"
        },
      },
    },
    title: {
      text: "",
      floating: true,
      offsetY: 330,
      align: "center",
      style: {
        color: "#444",
      },
    },
  }
  return (
    <Card className="mt-3 shadow-md h-100">
      <CardBody>
        <CardTitle className="mb-4">{t("customers_disputes")}</CardTitle>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={300}
          className="apex-charts"
        />
        <Row>
          {labels.map((label, index) => (
            <Col xs="4" key={index}>
              <div className="mt-4">
                <p className="mb-2 text-truncate">
                  <i
                    className={`mdi mdi-circle text-${basicColor[index]} me-1`}
                  />
                  {label}
                </p>
                <h5>{series[0].data[index]}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  )
}

export default Disputes
